import { LitElement, html, css } from 'lit';
import {property, customElement} from 'lit/decorators.js';
import { GetFormattedDate } from '../../../src/utils/helpers';
import { voyageCursorStyles } from '../../voyage-style/src/voyage-style';

@customElement('voy-map-wp-info')
export class VoyMapWPInfo extends LitElement
{
    @property({type: String}) eta: string = "";
    @property({type: String}) details: string = "";
    @property({type: Number}) planIndex: number = -1;

    static get styles()
    {
        return [
            voyageCursorStyles,
            css`
            :host {
                display: block;
                position: relative;
                margin: 0;
                padding: 0;
                width: 265px;
            }

            .container {
                font-size: 14px;
                display: flex;
                flex-direction: column;
                align-items: stretch;
                font-family: MaerskText;
                background-color: var(--neutrals-grey-10, white);
                border: 1px solid var(--neutrals-grey-07, grey);
            }

            .container > .container {
                border: none;
                padding: 10px;
            }

            .container > .container:last-child {
                border-top: solid 1px var(--neutrals-grey-07, grey);
            }

            .changeBtn {
                position: absolute;
                right: 10px;
                top: 10px;
                color: var(--primary-blue-05, blue);
                font-family: MaerskText;
                font-size: 12px;
                background: none;
                outline: none;
                border: none;
            }

            .header {
                font-size: 12px;
                color: var(--neutrals-grey-04, grey);
            }

            .info {
                color: var(--neutrals-grey-02, black);
            }
            `
        ];
    }

    render()
    {
        if (this.eta === "")
        {
            return html``;
        }

        return html`
        <div class="container">
            <button class="changeBtn" @click=${() => this._changeClicked()}>CHANGE</button>
            <div class="container">
                <div class="header">ETA</div>
                <div class="info">${GetFormattedDate(this.eta)}</div>
            </div>

            <div class="container">
                <div class="header">WAYPOINT DETAILS</div>
                <div class="info">${this.details}</div>
            </div>
        </div>
        `;
    }

    private _changeClicked()
    {
        this.dispatchEvent(new CustomEvent("change-wp-eta-clicked", { detail: { wpPlanIndex: this.planIndex }, bubbles: true, composed: true } ));
    }
};
